export default __webpack_public_path__ + "static/media/lecteurRFID1356.a189f8bb.jpg";